import { useCallback } from 'react';
import { myServices } from 'v5/services/services.connected.app';
import { useBrowsingWorkspaceForBookingConfirmation } from './useBrowsingWorkspaceForBookingConfirmation';

export type SendBookingConfirmationControl = {
  run: () => void;
};

/**
 * Returns send control for a booking, or `null` when `bookingId` is missing.
 * Opens the v5 send dialog; template lens follows browsing URL scope.
 * Missing-email (and other send problems) are shown in the dialog body.
 */
export function useSendBookingConfirmation(
  bookingId: number | null
): SendBookingConfirmationControl | null {
  const { appScope } = useBrowsingWorkspaceForBookingConfirmation();

  const run = useCallback(() => {
    if (bookingId == null) {
      return;
    }

    myServices.userFlowService.openSendBookingConfirmationDialog({
      appScope,
      bookingId
    });
  }, [appScope, bookingId]);

  if (bookingId == null) {
    return null;
  }
  return { run };
}
